import { cleanDoubleSlashes, joinURL, normalizeURL, withTrailingSlash } from 'ufo';

export default (base: string, endpoint: string, version = '1.0') => {
  return cleanDoubleSlashes(
    withTrailingSlash(
      normalizeURL(
        joinURL(base, 'api', version, endpoint, '/'),
      ),
      true,
    ),
  );
};
